import { render, staticRenderFns } from "./SiteBlogsConfig.vue?vue&type=template&id=6fa3fce6&"
import script from "./SiteBlogsConfig.vue?vue&type=script&lang=js&"
export * from "./SiteBlogsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports